<template>
  <div id="app">
    <keep-alive :include="getCache">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    getCache() {
      return this.$store.getters.getCache;
    },
  },
};
</script>
